import React from "react";

import withTitle from "../withTitle";
import { formatDateLocal, formatName, formatDateLocalMonth } from "../../Utilities";
import { V2 } from "../../Api";
import { RouteComponentProps } from "react-router";

interface IAssessmentSelfViewState {
    isLoading: boolean | string;
    assessments: any[];
}

class AssessmentSelfView extends React.Component<RouteComponentProps<any>, IAssessmentSelfViewState> {
    constructor(props: Readonly<RouteComponentProps<any>>) {
        super(props);

        const state: IAssessmentSelfViewState = {
            isLoading: true,
            assessments: []
        };

        this.state = state;
    }

    public componentDidMount() {
        this.loadAssessments();
    }

    public render() {
        return (
            <div className="viewer-root">
                <table className="table-vertical">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th className="col-smallest">Assessment By</th>
                            <th className="col-smallest">Last Updated</th>
                        </tr>
                    </thead>
                    <thead className="table-vertical-head-small">
                        <tr>
                            <th>Assessments</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.isLoading === true
                            ? <tr><td colSpan={10}><div className="spinner lds-dual-ring" /></td></tr>
                            : typeof this.state.isLoading === "string"
                                ? <tr><td colSpan={10} className="error-text">{this.state.isLoading}</td></tr>
                                : null}
                        {this.state.assessments.length < 1
                            ? <tr><td colSpan={10}>No assessments available</td></tr>
                            : this.state.assessments.map(a =>
                                <tr key={a.id || a.employeeId} className="clickable" onClick={() => this.goAssessment(a)}>
                                    <td>{formatDateLocalMonth(a.date)} Assessment</td>
                                    <td className="inline" data-caption="Assessment by: ">{formatName(a.assessedBy?.name) || "-"}</td>
                                    <td className="inline" data-caption="Last updated: ">{formatDateLocal(a.lastUpdated) || "-"}</td>
                                </tr>
                            )}
                    </tbody>
                </table>
            </div>
        );
    }

    private goAssessment(assessment: any) {
        this.props.history.push(`/assessment/${assessment.id}`);
    }

    private async loadAssessments() {
        try {
            this.setState({
                isLoading: true
            });

            const assessments = await V2.get<any[]>("metrics/assessments/own");

            this.setState({
                isLoading: false,

                assessments
            });
        }
        catch (e) {
            this.setState({
                isLoading: e.message || "Could not load assessments"
            });
        }
    }
}

export default withTitle("Your Assessments", AssessmentSelfView);